import React, { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import { EmptyList, Loading } from "../../../components";
import { parseSearchParams } from "../../../helpers/clean-object";

import { SearchProductInput } from "../components";
import { useLazyProducts } from "../hooks";
import { ProductsTable } from "../components/product-table";

export const Products = () => {
  const [searchParams] = useSearchParams();

  const [limit, _] = useState(25);
  const [search, { data, loading, fetchMore, error }] = useLazyProducts();
  console.log({ data, loading, error });

  useEffect(() => {
    search({
      variables: {
        limit,
        offset: 0,
        where: parseSearchParams(searchParams),
      },
    });
  }, []);

  useEffect(() => {
    search({
      variables: {
        limit,
        offset: 0,
        where: parseSearchParams(searchParams),
      },
    });
  }, [searchParams]);

  const renderList = () => {
    if (loading) return <Loading />;

    return data?.products?.results?.length &&
      data?.products?.results?.length > 0 ? (
      <ProductsTable
        iData={
          data?.products?.results?.map((product) => ({
            imgUrl: product?.imgUrl,
            product: { name: product?.name, id: product?.id },
            lastPrice: product.lastPrice + " €",
            lastQuantity: product.priceOnly ? "-" : product.lastQuantity,
            url: product.url,
          })) || []
        }
      />
    ) : (
      <EmptyList text="Aucun Résultat" />
    );
  };

  return (
    <>
      <div className="main-container">
        <SearchProductInput {...parseSearchParams(searchParams)} />

        <div className="card mb-2">{renderList()}</div>

        {data?.products?.hasMore ? (
          <div className="flex flex-wrap -mx-4 items-center justify-between">
            <div className="w-full lg:w-1/3 px-4 flex items-center mb-4 lg:mb-0"></div>

            <div className="w-full lg:w-auto px-4 flex items-center justify-center">
              <div
                className=" cursor-pointer inline-flex items-center justify-center px-2 h-8 text-xs text-white bg-indigo-500 rounded"
                onClick={() => {
                  fetchMore({
                    variables: {
                      offset: data?.products?.results?.length,
                      limit,
                      where: parseSearchParams(searchParams),
                    },
                  });
                }}
              >
                Charger Plus
              </div>
            </div>
          </div>
        ) : null}
      </div>
    </>
  );
};

// if (loading) return <Loading />;
// if (data?.products?.results?.length === 0) {
//   return <EmptyList text="Aucune Produit n'est enregistrée" />;
// }

// return (
//   <table className="table-auto w-full">
//     <thead>
//       <tr className="text-xs text-gray-500 text-left">
//         <th className="padding-table font-medium text-left "></th>
//         <th className="padding-table font-medium text-center ">Nom</th>
//         <th className="padding-table font-medium text-center ">Prix</th>
//         <th className="padding-table font-medium text-center">Quantité</th>
//         <th className="padding-table font-medium text-center">Boutique</th>
//       </tr>
//     </thead>
//     <tbody>
//       {data?.products?.results?.map((product, index) => (
//         <tr key={`product-${product.id}`} className={`text-xs`}>
//           <td className="padding-table text-center py-3">
//             <div>
//               <img
//                 src={product.imgUrl}
//                 alt=""
//                 width={80}
//                 height={80}
//                 className="rounded-full"
//               />
//             </div>
//           </td>

//           <td className="padding-table text-center py-3">
//             <div>
//               <a href={`/product/${product.id}`} className="">
//                 {product.name?.toLowerCase()}
//               </a>
//             </div>
//           </td>

//           <td className="padding-table text-center py-3">
//             <div>
//               <p className="font-medium cursor-pointer">
//                 {product.lastPrice} €{" "}
//               </p>
//             </div>
//           </td>

//           <td className="padding-table text-center py-3">
//             <div>
//               <p className="font-medium cursor-pointer">
//                 {product.lastQuantity}{" "}
//               </p>
//             </div>
//           </td>
//           <td className="padding-table text-center py-3">
//             <div>
//               <p className="font-medium cursor-pointer">
//                 {product.site?.name}
//               </p>
//             </div>
//           </td>
//         </tr>
//       ))}
//     </tbody>
//   </table>
// );
